const moduleConstants = {
  GET_MODULES: "GET_MODULES",
  GET_MODULES_SUCCESS: "GET_MODULES_SUCCESS",
  GET_MODULES_FAILURE: "GET_MODULES_FAILURE",
}

export default moduleConstants;
